import React, { useState, useEffect } from 'react';
import { Grid, Accordion, AccordionSummary, Typography, AccordionDetails } from "@mui/material";
import { ExpandMore } from '@mui/icons-material';
import excel from '../../../../assets/excel.png';
import axios from 'axios';
import Swal from 'sweetalert2';

interface DocumentoMemoria {
    id: string;
    titulo: string;
    comentarios: string;
    ruta: string;
}

interface Memoria {
    id: string;
    titulo: string;
    formula: string;
    orden: number;
    documentos: DocumentoMemoria[]; // Puede estar vacío si no hay documentos
}


const CalculosAEP = (
    { }: {}) => {

    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<Memoria[]>([]);
    const consulta = async () => {
        setLoading(true)
        var response = await axios({
            method: "get",
            url: process.env.REACT_APP_APPLICATION_ENDPOINT + "/public/consulta/ae/memorias",
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*"
            },
        })
            .then(({ data }) => {
                setLoading(false);
                if (data.data) {
                    setRows(data.data)
                } else {
                    setLoading(false)
                    return false;
                }
                return true;
            })
            .catch(function (error) {
                setRows([]);
                setLoading(false)
                const mensaje =
                    error?.response?.data?.error ||
                    error?.response?.data?.message ||
                    error?.message ||
                    'Ocurrió un error inesperado';

                Swal.fire({
                    icon: 'error',
                    title: 'Error en la consulta',
                    text: mensaje,
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#15212f",
                });
                return false;
            });
        return response;
    }

    const handleDescarga = (id: string) => {
        const url = `${process.env.REACT_APP_APPLICATION_ENDPOINT}/documentos/descarga/ae_doc_memoria/${id}`;
        window.open(url, '_blank');
    };
    useEffect(() => {
        consulta();
    }, []);

    return (
        <Grid container xs={12} mb={2}>
            <Grid item xs={12} md={12} mt={2}>
                {
                    rows.map((mem) => (
                        <Accordion key={mem.id}>
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <Typography component="span">{mem.titulo}</Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ padding: "8px" }}>
                                <Grid container>
                                    <Grid
                                        item xs={12} md={12} ml={4}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: mem.formula }} />
                                        <br />
                                    </Grid>
                                    {
                                        mem.documentos.length > 0 &&
                                        mem.documentos.map((d) => (
                                            <Grid
                                                item xs={12}
                                                onClick={() => handleDescarga(d.id)}
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 2,
                                                    cursor: 'pointer',
                                                    padding: '8px',
                                                    borderBottom: '1px solid #eee'
                                                }}
                                                key={d.id}
                                            >
                                                <img src={excel} alt={d.titulo} height={40} />
                                                <div>
                                                    <div style={{ fontWeight: 500 }}>{d.titulo}</div>
                                                    {d.comentarios && (
                                                        <div style={{ fontSize: '12px', color: '#666' }}>
                                                            <strong>Nota:</strong> {d.comentarios}
                                                        </div>
                                                    )}
                                                </div>
                                            </Grid>
                                        ))
                                    }
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                    ))
                }

                <br />
            </Grid>
        </Grid>

    );
};

export { CalculosAEP };